import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import logger from "redux-logger";
import rootReducer from "./reducers/index";

const initialState = {};
// const middleware = [thunk, logger];

const middlewareEnhancer = applyMiddleware(
  logger,
  thunk
);

const composedEnhancers = compose(
  middlewareEnhancer,
  // monitorReducerEnhancer,
  window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : (noop) => noop
);

const store = createStore(
  rootReducer,
  initialState,
  // applyMiddleware(...middleware),
  composedEnhancers
);

export default store;
